const deleteCategoryMutation = `
  mutation DeleteMarketplaceCategory($id: ID!) {
    deleteMarketplace_category(input: { id: $id }) {
      marketplace_category {
        objectId
      }
    }
  }
`
  .replace(/\r?\n|\r/g, "")
  .replace(/\t/g, " ");

export default deleteCategoryMutation;
